import { Moment } from 'moment'
import { ofType, unionize, UnionOf } from 'src/framework'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'

export interface InviteUserTest {
  type: 'InviteUserTest'
  email: string
  firstName: string
  lastName: string
  testId: string
  dueDate: Moment
  invitorToken: string
  [startFetch]: string
}

export interface InviteUserTestSuccess {
  type: 'InviteUserTestSuccess'
  [stopFetch]: string
}

export interface InviteUserTestFailure {
  type: 'InviteUserTestFailure'
  [stopFetch]: string
}

export const inviteUserTestActions = unionize({
  ...ofType<InviteUserTest>('InviteUserTest'),
  ...ofType<InviteUserTestSuccess>('InviteUserTestSuccess'),
  ...ofType<InviteUserTestFailure>('InviteUserTestFailure')
})

export type InviteUserTestActions = UnionOf<typeof inviteUserTestActions>



// WEBPACK FOOTER //
// ./src/tests-components/invite-user/invite-user-test.actions.ts